import postWithToken from './base/post-with-token'

const customerUpdateAction = (id, data) => postWithToken(`/customer-timeline/action/${id}`)(data)

export default customerUpdateAction